import React from "react";

export default function Documents() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Documents</h1>
      <p>Access your personal HR documents like contracts and tax forms.</p>

      <ul className="mt-4 space-y-2">
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">Employment Contract.pdf</li>
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">Payslip_December_2025.pdf</li>
        <li className="p-2 border rounded hover:bg-gray-100 cursor-pointer">TaxForm_2025.pdf</li>
      </ul>
    </div>
  );
}
